module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "calibre_6",
    attrs: {
      "id": "filepos18507"
    }
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('a'), _vm._v("First Sentient Publications edition, 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("Copyright © 2003 by Kegan Paul Limited.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("Grateful acknowledgment is made for permission to use Matt Errey’s editorial notes.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("All rights reserved. This book, or parts thereof, may not be reproduced in any form without permission, except in the case of brief quotations embodied in critical articles and reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cover design by Kim Johansen, Black Dog Design"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Book design by Anna Bergstrom")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_7"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("Wei, Wu Wei.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("Why Lazarus laughed : the essential doctrine Zen--Advaita--Tantra.--1st ed.")])]), _vm._v(" "), _c('blockquote', {
    staticClass: "calibre_9"
  }, [_c('p', {
    staticClass: "calibre_10"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("p. cm.")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("Includes index.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_8"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("ISBN 978-1-59181-226-5")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("1. Asia—Religion. 2. Philosophy, Asian. 3. Advaita. I. Title.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("BL1033 .W45 2003")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_11"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("202--dc22")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_12"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("                                                                           2003016343")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("SENTIENT PUBLICATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_5"
  }, [_c('span', {
    staticClass: "calibre6"
  }, [_vm._v("A Limited Liability Company"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("PO BOX 1851"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("BOULDER CO 80306"), _c('br', {
    staticClass: "calibre1"
  }), _c('a', {
    attrs: {
      "href": "http://www.sentientpublications.com",
      "target": "_blank"
    }
  }, [_vm._v("www.sentientpublications.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f616c368","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 72
// module chunks = 0